var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CraftWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fsNejODx~DrU3s3ZO64LLa",
    x1: 43.981,
    x2: 70.703,
    y1: -586.827,
    y2: -586.827,
    gradientTransform: "matrix(0 -1 -1 0 -561.576 78.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fsNejODx~DrU3s3ZO64LLa)",
    d: "M35.703,8.278l-15.3,15.5l-1.813,0.118c-1.025,0.067-1.99,0.504-2.716,1.23L12,29l6,6 l3.863-3.863c0.732-0.732,1.17-1.708,1.232-2.741l0.108-1.817l15.3-15.5L35.703,8.278z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#af2031",
    d: "M35.494,17.87c0.54-0.54,5.836-5.836,6.188-6.188c1.757-1.757,1.757-4.607,0-6.364 s-4.607-1.757-6.364,0c-0.352,0.352-5.648,5.648-6.188,6.188L35.494,17.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c94f60",
    d: "M26.837,15.213l4.95,4.95c0.391,0.391,1.024,0.391,1.414,0l2.293-2.293l-6.364-6.364l-2.293,2.293 C26.447,14.189,26.447,14.822,26.837,15.213z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fsNejODx~DrU3s3ZO64LLb",
    x1: 24,
    x2: 24,
    y1: 31.16,
    y2: 42.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97218"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fsNejODx~DrU3s3ZO64LLb)",
    d: "M41,31H7c-1.105,0-2,0.895-2,2v8c0,1.105,0.895,2,2,2h34c1.105,0,2-0.895,2-2v-8 C43,31.895,42.105,31,41,31z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fsNejODx~DrU3s3ZO64LLc",
    x1: 11.5,
    x2: 11.5,
    y1: 27.626,
    y2: 39.447,
    gradientTransform: "matrix(1 0 0 -1 0 52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fsNejODx~DrU3s3ZO64LLc)",
    d: "M5,19c0-5,4-8,9-8h3c0.552,0,1,0.448,1,1v4.005c0,0.55-0.448,0.994-0.998,1 C8.851,17.082,7,19.19,7,24C6,24,5,19,5,19z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fsNejODx~DrU3s3ZO64LLd",
    x1: 12.5,
    x2: 12.5,
    y1: 18.655,
    y2: 29.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab560c"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fsNejODx~DrU3s3ZO64LLd)",
    d: "M5,19c0,9,3,12,3,12h12C20,31,7,30,5,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CraftWork);
export default __webpack_public_path__ + "static/media/icons8-craft-work.b0e33104fdacf432af983665dadf6325.svg";
export { ForwardRef as ReactComponent };